export default __webpack_public_path__ + "assets/smart-vending-logo-white.png";